import {  Component, OnInit, HostListener, ViewChild, ElementRef, AfterViewInit} from '@angular/core';
import { PcrcApiService } from "../../api/pcrc-api.service";
import { StateService } from 'src/app/services/state.service';
import { EventsService } from 'src/app/services/events.service';
import { debounceTime } from 'rxjs/internal/operators/debounceTime';
import { distinctUntilChanged, pluck } from 'rxjs/operators';
import { fromEvent } from 'rxjs/internal/observable/fromEvent';
import { UserApiService } from '../../api/user-api.service';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'app-search-box',
    templateUrl: './search-box.component.html',
    styleUrls: ['./search-box.component.css']
})
export class SearchBoxComponent implements OnInit,AfterViewInit{
    @ViewChild('buscar',{static:false}) buscar:ElementRef

    texto=""
    lista=[]
    mostrar=false
    textBusuqeda:string = ""

    constructor(
        public PcrcApiService: PcrcApiService,
        public state:StateService,
        public events: EventsService,
        public userApi: UserApiService,
        private toastr:ToastrService,
        private translate:TranslateService
    ) { }

    ngOnInit() { }

    ngAfterViewInit(){

        const input$ = fromEvent(this.buscar.nativeElement,'keyup');

        input$.pipe(
            debounceTime(400),
            pluck('target','value'),
            distinctUntilChanged()
        ).subscribe(data=>{
            this.busqueda(data)
        })
    
    }

        Teclado(event:any){
            if (event.keyCode == 13){
                this.events.newSearch(this.texto)
                this.mostrar=false
                this.texto=""
            }    
        }
         

        busqueda(texto){
            this.mostrar = true

            let data={
                cedula:this.state.getValueOf('user').sub
            }

            this.userApi.validarPcrc(data).subscribe(data=>{
                
                if (data!=0) {
                    
                    let pcrc = this.state.getValueOf('selectedPcrc').id_dp_pcrc.toString()

                if(!texto){
                    this.mostrar=false
                    return
                } 

            this.PcrcApiService.getSuggestions(pcrc,texto).subscribe(
                data=>{
                    this.lista=data
                  
                }
            )

                }
                
            })

        }

        buscarArticulos(data){
            console.log(data)
            if(typeof this.textBusuqeda === "undefined"){
                return 
            }

            if(data.length > 50){
                 
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: this.translate.instant('Supera el maxino de caracteres permitidos') ,
                       
                    })
                return 
            }
            
            this.events.newSearch(data)
            this.mostrar=false
            this.texto=""
            this.lista=[]
            this.textBusuqeda= ""
        }


}
